import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import {
  getSuperbillGoals,
  getSuperbillGoal,
  createSuperbillGoal,
  updateSuperbillGoal,
  deleteSuperbillGoal,
  clearLocalSuperbillGoals,
  clearLocalActiveSuperbillGoal
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  superbillGoal: { 
    id: '', 
    clinician: { id: '', first_name: '', last_name: '' }, 
    emails: [],  
    updated_at: '' 
  },
  loading: { 
    all: false, 
    superbillGoal: false 
  }
};

const  slice = createSlice({
  name: 'superbillGoals',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSuperbillGoals.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getSuperbillGoals.fulfilled, (state, action) => {
        const { superbill_goals, pagination } = action.payload;
        
        state.loading.all = false;
        state.all.data = [...state.all.data, ...superbill_goals];
        state.all.pagination = pagination;
      })
      .addCase(getSuperbillGoals.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getSuperbillGoal.pending, (state) => {
        state.loading.superbillGoal = true;
      })
      .addCase(getSuperbillGoal.fulfilled, (state, action) => {
        const { superbill_goal } = action.payload;
        const foundedSuperbillGoal = !!_find(state.all.data, (m) => m.id === superbill_goal.id);
        const updatedSuperbillGoal = { ...state.superbillGoal, ...superbill_goal };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedSuperbillGoal ? _map(state.all.data, (m) => m.id === superbill_goal.id ? { ...m, ...superbill_goal } : m) : [...[superbill_goal], ...oldAllData]; 
        const pagination = foundedSuperbillGoal ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.superbillGoal = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedSuperbillGoal) state.superbillGoal = updatedSuperbillGoal;       
      })
      .addCase(getSuperbillGoal.rejected, (state) => {
        state.loading.superbillGoal = false;
      })
      .addCase(createSuperbillGoal.pending, (state) => {
        state.loading.superbillGoal = true;
      })
      .addCase(createSuperbillGoal.fulfilled, (state, action) => {
        const { superbill_goal } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[superbill_goal], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.superbillGoal = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        state.superbillGoal = superbill_goal;
      })
      .addCase(createSuperbillGoal.rejected, (state) => {
        state.loading.superbillGoal = false;
      })
      .addCase(updateSuperbillGoal.pending, (state) => {
        state.loading.superbillGoal = true;
      })
      .addCase(updateSuperbillGoal.fulfilled, (state, action) => {
        const { status, superbill_goal } = action.payload;
        const updatedSuperbillGoal = { ...state.superbillGoal, ...superbill_goal, ...(!!superbill_goal.localClinician && {clinician: superbill_goal.localClinician}) };
        const data = _map(state.all.data, (m) => m.id === updatedSuperbillGoal.id ? { ...m, ...updatedSuperbillGoal } : m)
        
        state.loading.superbillGoal = false;
        if (status === 204) {
          state.all.data = data;
          state.superbillGoal = updatedSuperbillGoal;
        }     
      })
      .addCase(updateSuperbillGoal.rejected, (state) => {
        state.loading.superbillGoal = false;
      })
      .addCase(deleteSuperbillGoal.pending, (state) => {
        state.loading.superbillGoal = true;
      })
      .addCase(deleteSuperbillGoal.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        
        state.loading.superbillGoal = false;
        if (status === 204) {
          state.all.data = _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
          state.superbillGoal = initialState.superbillGoal;
        }
      })
      .addCase(deleteSuperbillGoal.rejected, (state) => {
        state.loading.superbillGoal = false;
      })
      .addCase(clearLocalSuperbillGoals, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveSuperbillGoal, state => {
        state.superbillGoal = initialState.superbillGoal;
      })
  }
})

export default slice.reducer;